import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import {Menu, X, Shield} from 'lucide-react'

export default function Layout({ children }: { children: React.ReactNode }) {
  const [mobileMenuOpen, setMobileMenuOpen] = React.useState(false)
  const [disclaimerOpen, setDisclaimerOpen] = React.useState(false)
  const location = useLocation()

  return (
    <div className="min-h-screen text-white">
      {/* Navigation */}
      <nav className="fixed w-full top-0 z-50 bg-black/95 backdrop-blur-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <div className="flex items-center">
              <Link to="/" className="cursor-pointer">
                <img src="https://static.lumi.new/02/020a4968eeee7f3e302319d6b4557d90.webp" alt="Mandox Logo" className="h-16 sm:h-20 md:h-24 w-auto" />
              </Link>
            </div>
            
            {/* Menu Button */}
            <button 
              className="text-white"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            >
              {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {/* Menu Dropdown */}
        {mobileMenuOpen && (
          <div className="bg-black/95">
            <div className="px-4 py-4 space-y-3">
              <Link to="/" className="block text-white/70 hover:text-white" onClick={() => setMobileMenuOpen(false)}>About</Link>
              <Link to="/chart" className="block text-white/70 hover:text-white" onClick={() => setMobileMenuOpen(false)}>$Mandox</Link>
              <Link to="/nft" className="block text-white/70 hover:text-white" onClick={() => setMobileMenuOpen(false)}>NFT Collections</Link>
              <Link to="/battle-arena" className="block text-white/70 hover:text-white" onClick={() => setMobileMenuOpen(false)}>Battle Arena</Link>
              <Link to="/create-marketplace" className="block text-white/70 hover:text-white" onClick={() => setMobileMenuOpen(false)}>Create NFT Marketplace</Link>
              <Link to="/incinerator" className="block text-white/70 hover:text-white" onClick={() => setMobileMenuOpen(false)}>Incinerator</Link>
              <Link to="/mandox-exchange" className="block text-white/70 hover:text-white" onClick={() => setMobileMenuOpen(false)}>Mandox Exchange</Link>
              <Link to="/community" className="block text-white/70 hover:text-white" onClick={() => setMobileMenuOpen(false)}>Community</Link>
              <Link to="/smart-contract-audit" className="block hover:text-cyan-300 transition-colors flex items-center gap-2" style={{color: '#22d3ee'}} onClick={() => setMobileMenuOpen(false)}><Shield size={18} style={{color: '#40E0D0'}} /> Get a Smart Contract Audit</Link>
            </div>
          </div>
        )}
      </nav>

      {/* Main Content */}
      <main className="pt-16">
        {children}
      </main>

      {/* Disclaimer Modal */}
      {disclaimerOpen && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm" onClick={() => setDisclaimerOpen(false)}>
          <div className="relative bg-black border border-white/20 rounded-lg p-8 max-w-2xl w-full max-h-[80vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
            <button 
              onClick={() => setDisclaimerOpen(false)}
              className="absolute top-4 right-4 text-white/70 hover:text-white transition-colors"
            >
              <X size={24} />
            </button>
            <h2 className="text-white font-bold text-xl mb-6">Disclaimer</h2>
            <p className="text-white/70 text-sm leading-relaxed">
              The information provided on this website is for informational purposes only and does not constitute financial, investment, or legal advice. Cryptocurrency investments are highly volatile and carry significant risk. You should conduct your own research and consult with qualified financial advisors before making any investment decisions. MandoxToken and its team are not responsible for any financial losses incurred through the use of this website or participation in the $MANDOX ecosystem. Past performance is not indicative of future results. Always invest responsibly and only what you can afford to lose.
            </p>
          </div>
        </div>
      )}

      {/* Footer */}
      <footer className="relative py-12 px-4 z-10">
        <div className="max-w-7xl mx-auto text-center">
          <div className="mb-8">
            <div className="flex items-center justify-center mb-4">
              <img src="https://static.lumi.new/02/020a4968eeee7f3e302319d6b4557d90.webp" alt="Mandox Logo" className="h-32 w-auto" />
            </div>
            <p className="text-white/50 text-sm leading-relaxed">
              Building the future of decentralized finance and digital collectibles on Ethereum.
            </p>
          </div>

          <div className="mb-8 max-w-3xl mx-auto">
            <div className="text-center">
              <h4 className="text-white font-semibold mb-4 text-sm">Quick Links</h4>
              <ul className="space-y-2 text-white/50 text-sm">
                <li><Link to="/" className="hover:text-white transition-colors">About</Link></li>
                <li><Link to="/chart" className="hover:text-white transition-colors">$Mandox</Link></li>
                <li><Link to="/nft" className="hover:text-white transition-colors">NFT Collections</Link></li>
                <li><Link to="/battle-arena" className="hover:text-white transition-colors">Battle Arena</Link></li>
                <li><Link to="/create-marketplace" className="hover:text-white transition-colors">Create NFT Marketplace</Link></li>
                <li><Link to="/incinerator" className="hover:text-white transition-colors">Incinerator</Link></li>
                <li><Link to="/mandox-exchange" className="hover:text-white transition-colors">Mandox Exchange</Link></li>
                <li><Link to="/community" className="hover:text-white transition-colors">Community</Link></li>
                <li><Link to="/smart-contract-audit" className="hover:text-white transition-colors">Get a Smart Contract Audit</Link></li>
                <li><a href="https://static.lumi.new/54/5411c838effd7988eb6ee38390ae6d76.pdf" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">Whitepaper</a></li>
                <li><a href="https://coinsult.net/projects/mandox/" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">Audit</a></li>
              </ul>
            </div>

            <div className="mt-8 text-center">
              <button 
                onClick={() => setDisclaimerOpen(true)}
                className="text-white font-semibold text-sm hover:text-white/80 transition-colors cursor-pointer underline"
              >
                Disclaimer
              </button>
            </div>
          </div>

          <div className="pt-8">
            <p className="text-white/50 text-sm">
              © 2026 MandoxToken. All rights reserved.
            </p>
          </div>
        </div>
      </footer>
    </div>
  )
}
